import React from 'react';
import { Step4Size } from './steps/Step4Size';
import { Step5Quantity } from './steps/Step5Quantity';

/**
 * Wizard Page 2 — Size + Quantity picker block (compact).
 *
 * The hero Live AI Preview now lives OUTSIDE this component, rendered
 * directly by QuoteCalculator at the top of Page 2 so it can sit
 * prominently above the artwork upload as the visual centerpiece.
 *
 * This component now just stacks the compact Size and Quantity pickers
 * — it's intentionally small, mirroring the "keep it visually quiet
 * because the preview is the star" design direction.
 */
const CombinedSizeQuantity = ({
  // size props
  selectedShape,
  setSelectedShape,
  width,
  setWidth,
  height,
  setHeight,
  unit,
  setUnit,
  checkSizeLimit,
  handleCustomQuoteRequest,
  // white-ink options (only rendered when whiteInkEligible is true)
  whiteInkEligible,
  whiteInkOption,
  setWhiteInkOption,
  // quantity props
  requiresCustomQuoteAtQuantity,
  selectedProduct,
  selectedFormat,
  getQuantityConfig,
  calculateItemsPerPage,
  quantity,
  setQuantity,
  customQuantity,
  setCustomQuantity,
  calculatePrice,
  formatCurrency,
}) => (
  <div className="space-y-4">
    {/* Compact size block */}
    <div className="rounded-xl bg-white border border-gray-200 shadow-sm p-4" data-testid="page2-size-block">
      <Step4Size
        selectedShape={selectedShape}
        setSelectedShape={setSelectedShape}
        width={width}
        setWidth={setWidth}
        height={height}
        setHeight={setHeight}
        unit={unit}
        setUnit={setUnit}
        checkSizeLimit={checkSizeLimit}
        handleCustomQuoteRequest={handleCustomQuoteRequest}
        whiteInkEligible={whiteInkEligible}
        whiteInkOption={whiteInkOption}
        setWhiteInkOption={setWhiteInkOption}
        compact
      />
    </div>

    {/* Compact quantity block (custom-qty inline) */}
    <div className="rounded-xl bg-white border border-gray-200 shadow-sm p-4" data-testid="page2-quantity-block">
      <Step5Quantity
        requiresCustomQuoteAtQuantity={requiresCustomQuoteAtQuantity}
        selectedProduct={selectedProduct}
        selectedFormat={selectedFormat}
        width={width}
        height={height}
        unit={unit}
        getQuantityConfig={getQuantityConfig}
        calculateItemsPerPage={calculateItemsPerPage}
        quantity={quantity}
        setQuantity={setQuantity}
        customQuantity={customQuantity}
        setCustomQuantity={setCustomQuantity}
        calculatePrice={calculatePrice}
        formatCurrency={formatCurrency}
        compact
      />
    </div>
  </div>
);

export default CombinedSizeQuantity;
